import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DistrictLevelOfficialComponent } from 'src/app/dialogs/district-level-official/district-level-official.component';
import { DistrictData, DistrictOfficialData } from 'src/app/models/DistrictData';
import { DistrictOfficialService } from 'src/app/services/district-official.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  districts: DistrictData[] = [];
  selectedPolicyNo: number = 0;
  districtOfficialData: DistrictOfficialData[] = [];
  isError: boolean = false;

  constructor(private matDialog: MatDialog, private districtOfficialService: DistrictOfficialService){}
  ngOnInit():void{
    this.getDistrictList();
  }
  getDistrictList(){
    this.districts = [];
    this.districtOfficialService.getDistrictList().subscribe({
      next: (result:any) => {
        result.body.forEach((item: { policyno: number; state: string; client: string}) => {
         let data = {
              policyNo: item.policyno,
              state: item.state,
              client: item.client
            } as DistrictData;
            this.districts.push(data);
        });
      },
      error: (err: any) => {
        console.log(err);
      },
      complete: () => {
        console.log('complete');
      }
    });
  }
  OpenDistrictOfficialPopup(){
    
    if(this.selectedPolicyNo==0){
      this.isError = true;
      return;
    }
    this.isError =false;
    this.districtOfficialService.getDistrictOfficialData(this.selectedPolicyNo).subscribe({
      next: (result: any) => {
        this.districtOfficialData = result.body;
       
   this.matDialog.open(DistrictLevelOfficialComponent, {
      data: this.districtOfficialData
    })
      },
      error: (err: any) => {
        console.log(err);
      },
      complete: () => {
        console.log('complete');
      }
    });
    
  }
  checkDistrict(){
    if(this.selectedPolicyNo!=0){
      this.isError=false;
    }
  }
}
